module.exports = "\n<div role=\"tabpanel\" class=\"tab-pane\" :class=\"{active: active}\" :id=\"id\">\n    <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab.vue
// module id = 487
// module chunks = 0